export const WorkData = [
    {
        company:"CIBC",
        designation:"AI Scientist | Applied AI",
        dateJoining:"Jan 2025",
        dateEnd:"Ongoing",
        companyLogo: "/cibc.png",
        work: `Building and deploying GenAI solutions at CIBC, focusing on LLM-powered document processing, RAG systems, and agentic AI for internal banking teams. Collaborating efficiently with LOB stakeholders to define requirements, perform rigorous evaluations, and ensure high-accuracy outcomes. Work with AI scientists to develop secure APIs using FastAPI and LLM workflows using OpenAI and open-source models.`,
        link: "https://cibc.com/"
    },
    {
        company:"HumanFirst",
        designation:"AI Developer | Customer Success",
        dateJoining:"Jan 2024",
        dateEnd:"Dec 2024",
        companyLogo: "/HumanFirst.png",
        work: `Collaborated with data scientists to develop and implement generative AI projects, focusing on enterprise business use cases and data insights with the latest LLM models. Supported front-end team in SaaS product development using ReactJS and created Python scripts for processing large conversational datasets. Built a custom RAG chatbot deployed on a GCP VM. Handled relationships with an enteprise client portfolio and managed key objectives to ensure successful project delivery and SaaS usage.`,
        link: "https://humanfirst.ai/"
    }
    ,{
        company:"ParagonAI",
        designation:"Fullstack Dev | Freelance",
        dateJoining:"Oct 2023",
        dateEnd:"Jan 2024",
        companyLogo: "/paragon.png",
        work: `Built a responsive React chatbot application with a complex RAG architecture for extensive unstructured PDFs. Built a Flask backend on a GCP VM with secure JWT authentication and efficient logging for an Admin Portal, enhancing customer usage metrics visibility. Achieved recognition from Llama-Index and garnered over 10,000 views on YouTube for work with Pinecone and OpenAI embedding models.`,
        link: "https://www.youtube.com/@Paragon-AIAutomation"
    }

];